import React from "react";
import { adminService, networkErrorHelper, payloadBuilder, stringHelper } from "libs";
import { Container } from "design-react-kit";
import { withRouter } from "react-router-dom";
import { FormEnabler, MSelect, ValidatedForm } from "components/forms";
import { ModalHandler, MSection, Title } from "components/misc";
import { ROUTES } from "const";

class LessonActivityArchiveCreate extends ValidatedForm {
  emptyFields = {
    aa: 0,
    company: "",
    courseType: "",
  };

  constructor(props) {
    super(props);

    // bind event handler to invoke it from the child component
    this.onChange = this.onChange.bind(this);
  }

  state = {
    loading: true,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
  };

  FIELDS_GROUP = [
    [
      {
        id: "aa",
        field: "aa",
        label: "Anno accademico",
        component: MSelect,
        payload: {
          options: [
            { label: "Selezionare", value: 0 },
            { label: "2024/2025", value: 2024 },
            { label: "2025/2026", value: 2025 },
          ],
        },
        className: "col-md-4",
      },
      {
        id: "company",
        field: "company",
        label: "Università",
        component: MSelect,
        payload: {
          options: [
            { label: "Selezionare", value: "" },
            { label: "Unicamillus", value: "unicamillus" },
            { label: "Unitelma", value: "unitelma" },
            { label: "Reggio", value: "reggio" },
          ],
        },
        className: "col-md-4",
      },
      {
        id: "courseType",
        field: "courseType",
        label: "Tipo di corso",
        component: MSelect,
        payload: {
          options: [
            { label: "Selezionare", value: "" },
            { label: "60CFU", value: "ABILITAZIONI60CFU" },
            {
              label: "36ALL5",
              value: "CORSI36ALL5",
            },
          ],
        },
        className: "col-md-4",
      },
    ],
  ];

  ERROR_MESSAGES = {
    aa: "Campo obbligatorio",
    company: "Campo obbligatorio",
    courseType: "Campo obbligatorio",
  };

  validation = {
    aa: (value) => value !== 0,
    company: (value) => value !== "",
    courseType: (value) => value !== "",
  };

  onBackPage = () => {
    window.location.href = ROUTES.LESSON_ACTIVITY_ARCHIVE;
  };

  onSubmit = () => {
    if (!this.checkValidation()) return;

    const { aa, company, courseType } = this.state;
    const title = "Genera nuovo archivio tirocini diretti";
    const message = `Verrà generato un nuovo archivio dei tirocini diretti completati di ${stringHelper.capitalizeFirstLetter(company.value)} ${courseType.value} per l'anno accademico ${aa.value}/${parseInt(aa.value) + 1}. Vuoi procedere?`;

    ModalHandler.show(null, title, message, null, this.saveRemote);
  };

  saveRemote = () => {
    const payload = payloadBuilder(this.state);

    adminService
      .createLessonActivityArchive(payload)
      .then(() => {
        this.onBackPage();
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
      });
  };

  //--- ---

  render() {
    const { defaultValues } = this.state;

    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        <Title>Nuovo archivio </Title>

        <MSection>
          <Container>
            <div className="mt-3 p-3">{code}</div>

            <div>
              <FormEnabler onSubmit={this.onSubmit} onToggle={this.toggleForm} isFormActive={true} hideCancel={true} buttonText="Crea archivio" />
            </div>
          </Container>
        </MSection>
      </>
    );
  }
}

export default withRouter(LessonActivityArchiveCreate);
